var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-carousel',{attrs:{"height":"500px"}},_vm._l((_vm.bannerList),function(item){return _c('el-carousel-item',{key:item.lpid},[_c('img',{staticStyle:{"height":"100%","width":"100%"},attrs:{"src":item.cxfmtpurl,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }